/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { Page, Content, InContentMessage } from '@insticator/insticator-ui';
import PageHeader from "../../../../material/structure/pageheader/pageheader";
import PageContent from "../../../../material/structure/pagecontent/pagecontent";
// content
import SettingsHeader from '../settingsHeader';
import UsersConfig from './usersconfig/usersconfig';
import RolesManagement from './rolesmanagement/rolesmanagement';
// styles
import injectSheet from "react-jss";
import styles from './users_styles';

/* ========== ~~~~~~~~~~ USERS PAGE ~~~~~~~~~~ ========== */
const UsersPage = injectSheet(styles)((props) => {
  return (
    <Page name={'users'} klass={`${props.classes.users}`}>
      <SettingsHeader />
      <Content>
        <InContentMessage />
        <PageHeader title={'Settings'} subtitle={'Users'} />
        <PageContent>
          <UsersConfig />
          {/* <RolesManagement /> */}
        </PageContent>
      </Content>
    </Page>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default UsersPage;